import { render, staticRenderFns } from "./affordForm.vue?vue&type=template&id=fb59964e&"
import script from "./affordForm.vue?vue&type=script&lang=js&"
export * from "./affordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports